import React from "react";
import {TextField, InputAdornment, IconButton} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const SearchBar = ({value, onChange, onClear, placeholder = "Buscar..."}) => {
    return (
        <TextField
            fullWidth
            size="small"
            label="Realiza tu búsqueda"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            InputLabelProps={{shrink: true}}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        {value ? (
                            <IconButton onClick={onClear} edge="end">
                                <ClearIcon/>
                            </IconButton>
                        ) : (
                            <SearchIcon color="action"/>
                        )}
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default SearchBar;
